<template>
  <div>
    <a-modal
      :centered="true"
      :width="587"
      height="100%"
      v-model="showModal"
      :closable="closeButton"
      :footer="null"
      :bodyStyle="{ padding: '24px' }"
      @cancel="hide"
    >
      <div class="heading-container">
        <a-icon
          class="close-icon-size cp mr-3"
          type="close"
          style="font-size: 20px; color:#000000;"
          @click="hide"
        />
        <p class="heading">Filter</p>
        <button
          class="apply show"
          :style="{ background: getPrimaryColor() }"
          @click="apply"
        >
          Apply Filters
        </button>
      </div>
      <p class="sub-heading">First Name</p>
      <div class="input-container">
        <a-input
          type="search"
          size="large"
          class="search-field"
          placeholder="Enter first name"
          v-model="searchFirstName"
        />
      </div>
      <p class="sub-heading">Last Name</p>
      <div class="input-container">
        <a-input
          type="search"
          size="large"
          class="search-field"
          placeholder="Enter last name"
          v-model="searchLastName"
        />
      </div>
      <p class="sub-heading">City and state</p>
      <div class="search-input position-relative">
        <font-awesome-icon
          :icon="['fal', 'search']"
          :style="{ color: '#94A3B8', width: '20px' }"
          class="position-absolute search-icon"
        />
        <a-select
          show-search
          class="input-select-dropdown"
          size="large"
          placeholder="Search city"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :value="searchCity ? searchCity + ' , ' + searchState : undefined"
          @search="handleSelectLocation"
          @select="(val) => selectLocation(val)"
          :getPopupContainer="trigger => trigger.parentNode"
        >
          <a-select-option v-for="d in locationList" :key="JSON.stringify(d)">
            {{ d.city }}, {{ d.state }}
          </a-select-option>
        </a-select>
      </div>
      <p class="sub-heading">Specialty</p>
      <div class="search-input position-relative">
        <font-awesome-icon
          :icon="['fal', 'search']"
          :style="{ color: '#94A3B8', width: '20px' }"
          class="position-absolute search-icon"
        />
        <a-select
          show-search
          class="input-select-dropdown"
          size="large"
          placeholder="Search specialty"
          v-model="searchSpeciality"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="true"
        >
          <a-select-option
            v-for="s in specialities"
            :value="s.display_name"
            :key="s.id"
          >
            {{ s.display_name }}
          </a-select-option>
        </a-select>
      </div>
      <p class="sub-heading">Gender</p>
      <div class="gender-container">
        <div
          class="gender-button"
          v-bind:style="[
            searchGender === 'm'
              ? { color: 'white', background: getPrimaryColor() }
              : null
          ]"
          @click="searchGender = 'm'"
        >
          Male
        </div>
        <div
          class="gender-button"
          v-bind:style="[
            searchGender === 'f'
              ? { color: 'white', background: getPrimaryColor() }
              : null
          ]"
          @click="searchGender = 'f'"
        >
          Female
        </div>
        <!-- <div
          class="gender-button"
          v-bind:style="[
            searchGender === 'o'
              ? { color: 'white', background: getPrimaryColor() }
              : null
          ]"
          @click="searchGender = 'o'"
        >
          Other
        </div> -->
      </div>
      <a-checkbox class="sub-type" v-model:recommended="recommended"
        >Is Recommended</a-checkbox
      >
      <a-checkbox class="sub-type" v-model:premium="premium"
        >Is Premium</a-checkbox
      >
      <a-checkbox class="sub-type" v-model:claimed="claimed"
        >Is Claimed</a-checkbox
      >
      <div class="footer">
        <button class="cancel hide" @click="hide">Cancel</button>
        <button
          class="apply hide"
          :style="{ background: getPrimaryColor() }"
          @click="apply"
        >
          Apply Filters
        </button>
        <button
          class="cancel show w-100 mr-0"
          @click="clearFilters"
          :style="{
            background:
              searchCity != '' ||
              searchState !== '' ||
              searchSpeciality != undefined ||
              searchGender != '' ||
              searchFirstName != '' ||
              searchLastName != '' ||
              recommended ||
              claimed ||
              premium
                ? getPrimaryColor()
                : null,
            color:
              searchCity != '' ||
              searchState !== '' ||
              searchSpeciality != undefined ||
              searchGender != '' ||
              searchFirstName != '' ||
              searchLastName != '' ||
              recommended ||
              claimed ||
              premium
                ? 'white'
                : null,
            cursor:
              searchCity != '' ||
              searchState !== '' ||
              searchSpeciality != undefined ||
              searchGender != '' ||
              searchFirstName != '' ||
              searchLastName != '' ||
              recommended ||
              claimed ||
              premium
                ? 'pointer'
                : 'auto'
          }"
        >
          Clear filters
        </button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { faBookOpen } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { PropType } from "vue";

library.add(faBookOpen);

export default {
  name: "PhysicianDirectoryFilterModal",

  props: {
    handleAnswer: Function,
    searchCity: String,
    searchState: String,
    searchSpeciality: String,
    searchGender: String,
    specialities: Array,
    locationList: Array,
    handleSelectLocation: Function,
    searchFirstName: String,
    searchLastName: String,
    recommended: Boolean,
    premium: Boolean,
    claimed: Boolean
  },

  data() {
    return {
      showModal: false,
      Options: ["Is Recommended", "Is Premium", "Is Claimed"],
      closeButton: true
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    selectLocation(val) {
      const value = JSON.parse(val);
      this.searchCity = value.city;
      this.searchState = value.state;
    },
    clearFilters() {
      this.searchCity = "";
      this.searchState = "";
      this.searchSpeciality = undefined;
      this.searchGender = "";
      this.searchFirstName = "";
      this.searchLastName = "";
      this.recommended = false;
      this.premium = false;
      this.claimed = false;
    },
    handleResize() {
      if (window.innerWidth < 700) {
        this.closeButton = false;
      } else {
        this.closeButton = true;
      }
    },
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    apply() {
      this.hide();
      this.handleAnswer(
        this.searchCity,
        this.searchState,
        this.searchSpeciality,
        this.searchGender,
        this.searchFirstName,
        this.searchLastName,
        this.recommended,
        this.premium,
        this.claimed
      );
    }
  }
};
</script>

<style lang="scss">
.input-select-dropdown {
  width: 100%;
  .ant-select-selection--single {
    height: 56px !important;
    border-radius: 8px;
    border: 1px solid #cbd5e1;
    .ant-select-selection__rendered {
      .ant-select-search__field__placeholder,
      .ant-select-selection__placeholder {
        margin-top: 0px;
        padding-left: 38px;
      }
      .ant-select-no-arrow,
      .ant-select-selection-selected-value {
        margin-top: 10px;
        margin-left: 36px;
        padding-right: 50px;
      }
      .ant-select-search--inline {
        position: absolute;
        height: 100%;
        width: 100%;
        margin-left: 36px;
        margin-top: 8px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.heading-container {
  display: flex;
  align-items: center;
  padding-bottom: 28px;
  .heading {
    font-family: "Lato";
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    color: #33415f;
    flex: 1;
    margin-bottom: 0px;
    @media screen and (min-width: 701px) {
      font-size: 24px;
      line-height: 32px;
    }
  }
  .close-icon-size {
    @media screen and (min-width: 701px) {
      display: none;
    }
  }
}
.sub-heading {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #647490;
  margin-bottom: 4px;
}
.input-container {
  display: flex;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  width: 100%;
  align-items: center;
  margin-bottom: 24px;
  .search-field {
    border-radius: 8px;
    border: none;
    height: 56px;
    width: 100%;
  }
}
.search-input {
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 24px;
  width: 100%;
  .search-icon {
    left: 5px;
    font-size: 20px;
    color: #94a3b8;
    z-index: 1;
    margin-left: 12px;
  }
}
.gender-container {
  display: flex;
  gap: 10px;
  margin-bottom: 24px;
  .gender-button {
    background: #e2e8f0;
    border-radius: 6px;
    padding: 12px 24px;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #47556e;
    cursor: pointer;
  }
}
.sub-type {
  // display: flex;
  // flex-direction: column;
  // gap: 16px;
  display: block;
  margin-bottom: 16px;
  margin-left: 0px;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #647490;
  width: fit-content;
}
.footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 56px;
  @media screen and (max-width: 700px) {
    margin-top: 24px;
  }
}
.hide {
  @media screen and (max-width: 700px) {
    display: none;
  }
}
.show {
  @media screen and (min-width: 701px) {
    display: none;
  }
}

.cancel {
  padding: 12px 24px;
  background: #e2e8f0;
  border-radius: 6px;
  border: none;
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  color: #47556e;
  margin-right: 10px;
}

.apply {
  padding: 12px 24px;
  border-radius: 6px;
  border: none;
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
}

.mobile {
  @media screen and (min-width: 701px) {
    display: none;
  }
}

.desktop {
  @media screen and (max-width: 700px) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/PhysicianDirectoryFilterModal.vue